import script from "./roadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./roadmap.vue?vue&type=script&setup=true&lang=js"

import "./roadmap.vue?vue&type=style&index=0&id=58a1c501&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a1c501"]])

export default __exports__